class GiftCardBalanceChecker extends window.BAO.CustomElement() {
  static get requiredElements () {
    return [
      'form',
      'codeInput',
      'error',
      'submitBtn',
      'balanceCard',
      'balanceAmount',
    ]
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this.els.form.element,
      'submit',
      this._handleSubmit.bind(this),
    )
  }

  async _handleSubmit (e) {
    e.preventDefault()
    this._clearState()
    this._setLoading(true)

    const code = this.els.codeInput.element.value.trim()

    if (!code) {
      this._showError(window.giftCardBalanceStrings.errorEmptyCode)
      this._setLoading(false)
      return
    }

    try {
      const res = await fetch(
        `${this.dataset.appUrl}/api/gift-cards/check-balance?shop=${encodeURIComponent(this.dataset.shop)}`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ code }),
        },
      )
      const json = await res.json()

      if (!json.ok) {
        this._showError(
          json.message || window.giftCardBalanceStrings.errorNotFound,
        )
      } else {
        this._showBalance(json.data)
      }
    } catch {
      this._showError(window.giftCardBalanceStrings.errorGeneric)
    } finally {
      this._setLoading(false)
    }
  }

  _showBalance ({ balance, expiresOn }) {
    const formatted = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: balance.currencyCode,
      currencyDisplay: 'narrowSymbol',
    }).format(balance.amount)

    this.els.balanceAmount.element.textContent = formatted

    if (this.els.expiry.exists && expiresOn) {
      const date = new Date(expiresOn).toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
      this.els.expiry.element.textContent =
        window.giftCardBalanceStrings.expires.replace('__DATE__', date)
      this.els.expiry.element.removeAttribute('hidden')
    }
  }

  _showError (msg) {
    this.els.error.element.textContent = msg
    this.els.error.element.removeAttribute('hidden')
  }

  _clearState () {
    this.els.error.element.setAttribute('hidden', '')
    this.els.balanceAmount.element.textContent = '—'

    if (this.els.expiry.exists) {
      this.els.expiry.element.setAttribute('hidden', '')
    }
  }

  _setLoading (loading) {
    this.els.submitBtn.element.disabled = loading
    this.els.submitBtn.element.setAttribute('aria-busy', String(loading))
  }
}

if (!customElements.get('gift-card-balance-checker')) {
  customElements.define('gift-card-balance-checker', GiftCardBalanceChecker)
}
